import {useEffect} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {USP_LISTING_TILE_AB_TEST_ID, USP_LISTING_TILE_CONTROL_VARIANT, USP_LISTING_TILE_TREATMENT_VARIANT} from "../../ab_testing/usp_listing_tile_ab_test";

let hasTrackedExposure = false;

export const useUspListingTileExperiment = () => {
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: USP_LISTING_TILE_AB_TEST_ID,
        variants: [USP_LISTING_TILE_CONTROL_VARIANT, USP_LISTING_TILE_TREATMENT_VARIANT],
        withSSR: true,
        pushEventOnlyOnce: true
    });
    const hasAssignedVariant =
        canABTestBeRendered && (abTestVariant === USP_LISTING_TILE_CONTROL_VARIANT || abTestVariant === USP_LISTING_TILE_TREATMENT_VARIANT);

    useEffect(() => {
        if (!hasAssignedVariant || hasTrackedExposure) {
            return;
        }

        hasTrackedExposure = true;

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(USP_LISTING_TILE_AB_TEST_ID));
    }, [hasAssignedVariant]);

    return {
        isUspVariant: canABTestBeRendered && abTestVariant === USP_LISTING_TILE_TREATMENT_VARIANT,
        variant: abTestVariant
    };
};
import {useEffect} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {USP_LISTING_TILE_AB_TEST_ID, USP_LISTING_TILE_CONTROL_VARIANT, USP_LISTING_TILE_TREATMENT_VARIANT} from "../../ab_testing/usp_listing_tile_ab_test";

let hasTrackedExposure = false;

export const useUspListingTileExperiment = () => {
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: USP_LISTING_TILE_AB_TEST_ID,
        variants: [USP_LISTING_TILE_CONTROL_VARIANT, USP_LISTING_TILE_TREATMENT_VARIANT],
        withSSR: true,
        pushEventOnlyOnce: true
    });
    const hasAssignedVariant =
        canABTestBeRendered && (abTestVariant === USP_LISTING_TILE_CONTROL_VARIANT || abTestVariant === USP_LISTING_TILE_TREATMENT_VARIANT);

    useEffect(() => {
        if (!hasAssignedVariant || hasTrackedExposure) {
            return;
        }

        hasTrackedExposure = true;

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(USP_LISTING_TILE_AB_TEST_ID));
    }, [hasAssignedVariant]);

    return {
        isUspVariant: canABTestBeRendered && abTestVariant === USP_LISTING_TILE_TREATMENT_VARIANT,
        variant: abTestVariant
    };
};
